import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { LoadingState } from "../../../state-message";
import styles from "../../kanban.module.scss";
import type { KanbanColumnViewModel } from "./types-column";

export function KanbanColumnView({
  rest,
  className,
  style,
  title,
  titleId,
  count,
  loading,
  loadingLabel,
  error,
  cards,
  isEmpty,
  emptyMessage,
  showMore,
  showLoadMore,
  loadingMore,
  loadMoreLabel,
  loadMore,
  testId,
  countTestId,
  emptyTestId,
  loadingTestId,
  loadMoreTestId,
  bodyTestId,
}: KanbanColumnViewModel) {
  return (
    <section
      className={classNames(styles.column, className)}
      style={style}
      data-testid={testId}
      {...rest}
      aria-labelledby={titleId}
      data-show-more={showMore}
    >
      <header className={styles.header}>
        <h2 id={titleId} className={styles.title}>
          {title}
        </h2>
        <Badge value={count} className={styles.count} data-testid={countTestId} />
      </header>

      <div className={classNames(styles.body, "scrollbar-compacta")} data-testid={bodyTestId}>
        {loading ? (
          <div className={styles.loading}>
            <LoadingState size="sm" label={loadingLabel} testId={loadingTestId} />
          </div>
        ) : null}
        {error ? (
          <p className={styles.error} role="alert">
            {error}
          </p>
        ) : null}
        {isEmpty ? (
          <p className={styles.empty} data-testid={emptyTestId}>
            {emptyMessage}
          </p>
        ) : null}
        {cards}
        {showLoadMore ? (
          <Button
            type="button"
            className={styles.loadMore}
            label={loadMoreLabel}
            loading={loadingMore}
            disabled={loadingMore}
            onClick={loadMore}
            data-testid={loadMoreTestId}
            severity="secondary"
            outlined
            size="small"
          />
        ) : null}
      </div>
    </section>
  );
}
